module.exports = __webpack_public_path__ + "static/media/GQ_OIS_ERP.71dbf220.png";